export const GET_ORDER_HISTORY_REQUEST = 'GET_ORDER_HISTORY_REQUEST';
export const GET_ORDER_HISTORY_SUCCESS = 'GET_ORDER_HISTORY_SUCCESS';
export const GET_ORDER_HISTORY_FAILURE = 'GET_ORDER_HISTORY_FAILURE';
export const SET_ORDER_HISTORY_MODAL_VISIBLE = 'SET_ORDER_HISTORY_MODAL_VISIBLE';
